import { Alert, Stack } from '@mui/material';
import { FC, useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import FacebookAddPasswordForm from '../../components/FacebookAddPasswordForm/FacebookAddPasswordForm';
import FacebookAddPasswordSuccess from '../../components/FacebookAddPasswordSuccess/FacebookAddPasswordSuccess';
import { Loader } from '../../components/Loader/Loader';
import FacebookAddPasswordContext, {
    EFacebookAddPasswordUiState,
    FacebookAddPasswordProvider,
} from '../../contexts/FacebookAddPasswordContext';
import GlobalContext from '../../contexts/GlobalContext';
import PageLayoutV2 from '../../layout/PageLayoutV2/PageLayoutV2';
import { ERoutes } from '../../util/constants';

const FacebookAddPasswordRouter: FC = () => {
    return (
        <Switch>
            <Route exact path={ERoutes.facebookAddPassword}>
                <FacebookAddPasswordForm />
            </Route>
            <Route path={ERoutes.facebookAddPasswordSuccess}>
                <FacebookAddPasswordSuccess />
            </Route>
        </Switch>
    );
};

const FacebookAddPasswordUi: FC = () => {
    const { language } = useContext(GlobalContext);
    const { facebookAddPasswordUiState } = useContext(FacebookAddPasswordContext);
    switch (facebookAddPasswordUiState) {
        case EFacebookAddPasswordUiState.default:
        case EFacebookAddPasswordUiState.queryStringParsed:
            return (
                <PageLayoutV2 showFooter={false}>
                    <Stack direction={'row'} sx={{ justifyContent: 'center' }}>
                        <Loader />
                    </Stack>
                </PageLayoutV2>
            );
        case EFacebookAddPasswordUiState.ready:
            return <FacebookAddPasswordRouter />;
        case EFacebookAddPasswordUiState.success:
            return (
                <>
                    <Redirect to={ERoutes.facebookAddPasswordSuccess} />
                    <FacebookAddPasswordRouter />
                </>
            );
        case EFacebookAddPasswordUiState.fatalError:
            return <Redirect to={ERoutes.error} />;

        default:
            console.error('FacebookAddPassword Ui State set incorrectly');
            return <Alert severity="error">{language.error.generic}</Alert>;
    }
};

const FacebookAddPasswordScreen: FC = () => {
    return (
        <FacebookAddPasswordProvider>
            <FacebookAddPasswordUi />
        </FacebookAddPasswordProvider>
    );
};

export default FacebookAddPasswordScreen;
